<template>
  <!-- Header Card -->
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-body p-15 p-sm-20 p-md-25">
      <h3 class="text-lg font-semibold">{{ noteReturn.note_ref }}</h3>
      <div class="mt-2 text-gray-600">
        Date de création :
        <b v-if="noteReturn.created_at">
          {{ getDate(noteReturn.created_at) }} </b
        ><br />

        <b>
          {{ noteReturn.for_name }}
        </b>
      </div>
    </div>
  </div>

  

  <!-- Liste des colis ajoutés -->
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing" v-if="Object.keys(noteReturn).length != 0 && noteReturn.statut== 2">
    <div class="border-b p-4">
      <h3 class="text-lg font-semibold">Liste des colis ajoutés</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          v-if="auth.can('ADD_BR_Z') && noteReturn.statut == 0"
          @click="removeNewColis"
        >
          Supprimer
          <i class="flaticon-delete position-relative ms-5 fs-12"></i>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          @input="getRows1()"
          v-model="users1.searchTerm"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Chercher"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table
        :search-options="{ enabled: true, externalQuery: searchTerm2 }"
        :columns="columns"
        :row-key="'id'"
        :rows="rows1"
        responsive
        :select-options="{
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis sélectionées',
        }"
        @select-all="onSelectAll"
        @selected-rows-change="selectionChanged"
      >
        <template #emptystate>
          <div class="text-center py-4 text-gray">
            Aucune entrées correspondants trouvés
          </div>
        </template>

        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="icon-repeat"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="icon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>

          <span v-else-if="props.column.field === 'last_statut_comment'">
                <!-- <h5>{{ props.row.last_statut_comment }}</h5> -->
                 <div
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': secondStatusColor(props.row.last_statut_comment) }"
                >
                  {{ props.row.last_statut_comment }}
                </div>
              </span>
              <template v-else-if="props.column.field === 'status'">

                <template v-if="props.row.delivered_by !=0">
                  <div
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': globalStore.globalHelper('DELIVERED').code_color }"
                >
                  {{ globalStore.globalHelper('DELIVERED').name }}
                </div>
                </template>

                <template v-if="props.row.delivered_by==0 && (props.row.status_second || props.row.status_second != null) ">
                  <div
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': globalStore.globalHelper(props.row.status_second).code_color }"
                >
                  {{ globalStore.globalHelper(props.row.status_second).name }}
                </div>
                </template>
                <template v-if="props.row.delivered_by==0 && (!props.row.status_second || props.row.status_second == null) ">
                <div
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': props.row.code_color }"
                >
                  {{ props.row.s_name }}
                </div>
                </template>
                <template v-else-if="props.column.field === 'received_time'">
                <span class="text-nowrap" v-if="props.row.received_time">
                  {{ getDate(props.row.received_time) }}
                </span>
                <span class="text-nowrap" v-else> </span>
              </template>
              </template>


          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users1"
        :offset="9"
        @paginate="getRows1"
      />
    </div>
  </div>

  <div
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
    v-if="Object.keys(noteReturn).length != 0 && noteReturn.statut == 2"
  >
    <div class="card-header">
      <h6>Scan code suivi</h6>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <form v-on:submit.prevent="searchColis">
        <div class="custom-search">
          <div class="row">
            <div class="col-md-9">
              <div class="form-group">
                <label>Code Suivi :</label>
                <input
                  placeholder="Code Suivi"
                  type="text"
                  id="scanFocus"
                  ref="scaninput"
                  v-model="codeColis"
                  class="form-control"
                />
              </div>
            </div>

            <div class="col-md-3">
              <button
                style="margin-right: 12px"
                class="btn btn-success me-3 mb-3 mt-3"
                type="submit"
              >
                <i class="ph ph-scan"></i>
              </button>
            </div>
            <div class="col-12">
              <hr />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Liste des nouveaux colis -->
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="border-b p-4">
      <h3 class="text-lg font-semibold">Liste des colis Reçus (Agence principale)</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
      
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          v-model="users2.searchTerm"
          @input="getRows2()"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Chercher"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table
        :columns="columns"
        :rows="rows2"
        :row-key="'id'"
        :select-options="{
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Demandes Sélectionées',
        }"
        @selected-rows-change="onSelectAllColis"
        @select-all="selectionChangedColis"
      >
        <template #emptystate>
          <div class="text-center py-4 text-gray">
            Aucune entrées correspondants trouvés
          </div>
        </template>

        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="icon-repeat"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="icon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <span v-else-if="props.column.field === 'last_statut_comment'">
                <!-- <h5>{{ props.row.last_statut_comment }}</h5> -->
                 <div
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': secondStatusColor(props.row.last_statut_comment) }"
                >
                  {{ props.row.last_statut_comment }}
                </div>
              </span>
              <template v-else-if="props.column.field === 'status'">

                <template v-if="props.row.delivered_by !=0">
                  <div
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': globalStore.globalHelper('DELIVERED').code_color }"
                >
                  {{ globalStore.globalHelper('DELIVERED').name }}
                </div>
                </template>

                <template v-if="props.row.delivered_by==0 && (props.row.status_second || props.row.status_second != null) ">
                  <div
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': globalStore.globalHelper(props.row.status_second).code_color }"
                >
                  {{ globalStore.globalHelper(props.row.status_second).name }}
                </div>
                </template>
                <template v-if="props.row.delivered_by==0 && (!props.row.status_second || props.row.status_second == null) ">
                <div
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': props.row.code_color }"
                >
                  {{ props.row.s_name }}
                </div>
                </template>
                <template v-else-if="props.column.field === 'received_time'">
                <span class="text-nowrap" v-if="props.row.received_time">
                  {{ getDate(props.row.received_time) }}
                </span>
                <span class="text-nowrap" v-else> </span>
              </template>
              </template>

          <template v-else-if="props.column.field === 'received_time'">
            <span class="text-nowrap">
              {{ getDate(props.row.received_time) }}
            </span>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users2"
        :offset="9"
        @paginate="getRows2"
      />
    </div>
  </div>

  
</template>

<script lang="ts">
import api from "@/utils/axios";
import moment from "moment";
import { reactive, ref, getCurrentInstance, onMounted } from "vue";
import { defineComponent } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import { useGlobalStore } from "@/stores/global";
export default defineComponent({
  name: "ScanReturn",
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const globalStore = useGlobalStore();
    const route = useRoute();

    const AgenciesList = ref([]);
    const ClientsList = ref([]);
    const AgencyStockList = ref([]);
    const isLoader = ref(true);
    const searchTerm1 = ref("");
    const searchTerm2 = ref("");
    const pageLength = ref(10);
    const pageLength2 = ref(10);

    const columns = [
      {
          label: "Code Suivi",
          field: "code",
        },
        {
          label: "Client",
          field: "customer_name",
        },
        {
          label: "Date de réception",
          field: "received_time",
        },
        {
          label: "Ville",
          field: "city_name",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Status Retour",
          field: "last_statut_comment",
        },
        {
          label: "Prix",
          field: "price",
        },
    ];

    const SelectedRows = ref([]);
    const SelectedNewRows = ref([]);
    const codeColis = ref("");
    const rows1 = ref([]);
    const rows2 = ref([]);
    const noteReturn = ref<any>({});
    const color = ref("");
    const config = reactive({
      mode: "range",
      locale: "fr",
    });
    const users = reactive({
      searchSDate: "",
      searchEDate: "",
    });
    const date_filter = ref("");
    const LivreurList = ref([]);
    const liv_filter = reactive({ id: "", name: "" });
    const status_filter = reactive({ id: "", name: "", code: "" });
    const StatusList = ref([]);
    const CitiesList = ref([]);
    const city_filter = reactive({ id: "", name: "" });

    const users1 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
      searchStatut: "",
      searchLiv: "",
      searchCity: "",
    });
    const users2 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const load = ref(false);

    const router = useRouter();
    const instance = getCurrentInstance();

    function getDate(value: string) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    const ColorStatu = async (status: string) => {
      try {
        const res = await api.get(`/api/auth/ColorStatus?status=${status}`);
        color.value = res.data;
      } catch (e) {
        console.error(e);
      }
    };

    const resolveStatu = (status: string) => {
      switch (status) {
        case "POSTPONED":
          return "Reporté";
        case "DELIVERED":
          return "Livré";
        case "PAID":
          return "Payé";
        case "NOT_PAID":
          return "Non Payé";
        case "Payé":
          return "info";
        case "CANCELED":
          return "Annulé";
        case "UNREACHABLE":
          return "Injoignable";
        case "RETURNED":
          return "Retourné";
        case "RECEIVED":
          return "Reçu";
        case "OUT_OF_AREA":
          return "Hors-zone";
        case "NOANSWER":
          return "Pas de réponse + SMS";
        case "SENTED":
          return "Expédié";
        case "REFUSE":
          return "Refusé";
        default:
          return status;
      }
    };

    function searchColis() {
      let data = new FormData();
      data.append("user_id", user?.id);
      data.append("code_colis", codeColis.value);
      data.append(
        "ref_note",
        Array.isArray(route.params.refNote)
          ? route.params.refNote.join(",")
          : route.params.refNote
      );
      api.post(`/api/auth/ReturnScanColis`, data).then((res) => {
        codeColis.value = "";
        if (res.data.message == "success") {
          //   var audio = new Audio(require("@/assets/sound.mp3"));
          //   audio.play();
          showToast("Ajouté avec succès", "success");
          getData();
        } else if (res.data.message == "parcel exit") {
          //   var audio = new Audio(require("@/assets/erro.mp3"));
          //   audio.play();
          showToast("Colis déjà existe dans ce bon !", "error");
        } else {
          showToast("Vous pouvez pas ajouter ce colis !", "error");
        }
      });
    }

    function onSelectAll(params: any) {
      SelectedRows.value = params.selectedRows;
    }
    function selectionChanged(params: any) {
      SelectedRows.value = params.selectedRows;
    }
    function onSelectAllColis(params: any) {
      SelectedNewRows.value = params.selectedRows;
    }
    function selectionChangedColis(params: any) {
      SelectedNewRows.value = params.selectedRows;
    }

    function getData() {
      isLoader.value = true;
      api
        .get(`/api/auth/show_bon_rn_ag`, {
          params: { ref: route.params.refNote },
        })
        .then((res) => {
          noteReturn.value = res.data.Note;
          
        });
      getRows1();
      getRows2();
      isLoader.value = false;
    }

    function getRows1(page = 1) {
      users1.current_page = page;
      load.value = true;
      api
        .get(
          `/api/auth/listColisInBrna?searchTerm=${users1.searchTerm}&page=${users1.current_page}&per_page=${users1.per_page}`,
          {
            params: {
              ref: route.params.refNote,
            //   searchSDate: users.searchSDate,
            //   searchEDate: users.searchEDate,
            },
          }
        )
        .then((res) => {
          rows1.value = res.data.users.data;
          Object.assign(users1, res.data.users);
        })
        .finally(() => {
          load.value = false;
        });
    }

    function getRows2(page = 1) {
      users2.current_page = page;
      api
        .get(
          `/api/auth/ColiInNoteSaved?searchTerm=${users2.searchTerm}&page=${users2.current_page}&per_page=${users2.per_page}`,
          {
            params: { ref: route.params.refNote },
          }
        )
        .then((res) => {
          rows2.value = res.data.users.data;
          Object.assign(users2, res.data.users);
        });
    }

    function addNewColis() {
      if (SelectedRows.value.length == 0) {
        showToast("Vous pouvez pas ajouter à ce bon", "error");
      } else {
        let data = new FormData();
        data.append("UserID", user?.id);
        data.append("colis", JSON.stringify(SelectedRows.value));
        data.append(
          "ref_note",
          Array.isArray(route.params.refNote)
            ? route.params.refNote[0]
            : String(route.params.refNote)
        );
        api.post(`/api/auth/ListColisToScan`, data).then((res) => {
          if (res.data.message == "success") {
            // var audio = new Audio(require("@/assets/sound.mp3"));
            // audio.play();
            showToast("Ajouté avec succès", "success");
            getData();
          } else {
            showToast("Une erreur est survenue, veuillez réessayer", "error");
          }
        });
      }
    }

    function removeNewColis() {
      if (SelectedNewRows.value.length == 0) {
        showToast("Vous pouvez pas supprimer à ce bon");
      } else {
        let data = new FormData();
        data.append("UserID", user?.id);
        data.append("colis", JSON.stringify(SelectedNewRows.value));
        data.append(
          "ref_note",
          Array.isArray(route.params.refNote)
            ? route.params.refNote[0]
            : String(route.params.refNote)
        );
        api.post(`/api/auth/RemoveScanColisRn`, data).then((res) => {
          if (res.data.message == "success") {
            // var audio = new Audio(require("@/assets/sound.mp3"));
            // audio.play();
            showToast("Supprimé avec succès", "success");
            getData();
          } else if (res.data.message == "error") {
            // var audio = new Audio(require("@/assets/erro.mp3"));
            // audio.play();
            showToast("Vous pouvez pas retirer de ce bon", "error");
          } else {
            showToast("Une erreur est survenue, veuillez réessayer", "error");
          }
        });
      }
    }

    function convert(str: string) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }

    function FilterColis() {
      const $refs = instance?.proxy?.$refs;
      // users.searchSDate =
      //   $refs?.myInput?.dateRange?.start === undefined
      //     ? ""
      //     : convert($refs.myInput.dateRange.start);
      // users.searchEDate =
      //   $refs?.myInput?.dateRange?.end === undefined
      //     ? ""
      //     : convert($refs.myInput.dateRange.end);

      users1.searchStatut = status_filter.code;
      users1.searchLiv = liv_filter.id;
      users1.searchCity = city_filter.id;

      getRows1();
    }

    function Removefilter() {
      const $refs = instance?.proxy?.$refs;
      // if ($refs?.myInput) $refs.myInput.dateRange = {};
      users.searchSDate =
        users.searchEDate =
        users1.searchStatut =
        users1.searchLiv =
        users1.searchCity =
          "";
      date_filter.value = "";
      liv_filter.id = "";
      liv_filter.name = "";
      city_filter.id = "";
      city_filter.name = "";
      status_filter.id = "";
      status_filter.name = "";
      status_filter.code = "";
      getRows1();
    }

    onMounted(async () => {
      getData();
      try {
        const response = await api.get(`/api/auth/status_list`);
        if (response && response.data) {
          StatusList.value = response.data;
          StatusList.value.unshift({ id: "", name: "Tous" });
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }

      try {
        const response = await api.get(`/api/auth/LivsList`);
        if (response && response.data) {
          LivreurList.value = response.data;
          LivreurList.value.unshift({ id: "", name: "Tous" });
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    });

    function secondStatusColor(x){
      if(x){
        if(x == "Préparation Retour") return "#F62038";
        if(x == "Expédier vers agence principale") return "#E17B07";
        if(x == "Reçu par agence principale") return "#59BB09";
        if(x.includes("Expédier vers client")) return "#E5E30A";
        if(x.includes("Reçu par agence")) return "#2D5BF0";
        if(x.includes("Reçu par client")) return "#0AD1E5";
        else return "#00a884"  
      }else{
        return false;
      }
      

    }

    return {
      AgenciesList,
      ClientsList,
      AgencyStockList,
      isLoader,
      searchTerm1,
      searchTerm2,
      pageLength,
      pageLength2,
      columns,
      SelectedRows,
      SelectedNewRows,
      codeColis,
      rows1,
      rows2,
      noteReturn,
      color,
      config,
      users,
      date_filter,
      LivreurList,
      liv_filter,
      status_filter,
      StatusList,
      CitiesList,
      city_filter,
      users1,
      users2,
      load,
      getDate,
      ColorStatu,
      resolveStatu,
      searchColis,
      onSelectAll,
      selectionChanged,
      onSelectAllColis,
      selectionChangedColis,
      getData,
      getRows1,
      getRows2,
      addNewColis,
      removeNewColis,
      convert,
      FilterColis,
      Removefilter,

      globalStore,
      auth,
      secondStatusColor
    };
  },
});
</script>
